import { TransformerSet } from '../../../contexts/RequestsContext/constants';
import { TemplateInstance } from '../../../types';
import { ConstructPost } from '../../types/ConstructPost';
import { NonPaginatedResponse } from '../../types/NonPaginatedResponse';
import { SIGNATURE_BASE_PATH } from '../constants/signatureBasePath';
import { CreateTemplateInstancePayload } from '../types/CreateTemplateInstancePayload';

export const createTemplateInstance = (
  constructPost: ConstructPost,
  data: CreateTemplateInstancePayload,
): Promise<NonPaginatedResponse<TemplateInstance> | undefined> =>
  constructPost<NonPaginatedResponse<TemplateInstance>>(
    `${SIGNATURE_BASE_PATH}/template-instance`,
    { data },
    {
      transformerSet: TransformerSet.PreserveKeys,
      preventDefaultErrorToast: true,
    },
  );
